// Device field definitions shared across components

// These are the fields visible in the table - used for default selection
export const DEVICE_TABLE_DEFAULT_FIELDS = [
    'SiteName',
    'NetworkComputerName',
    'NetworkIpAddress',
    'SystemManufacturer',
    'SystemSerialNumber',
    'OsVersion',
    'OsLastLoggedOnUser',
    'SystemLaptop',
    'DeviceOnline',
    'HardwareReadinessResult',
    'WarrantyStatus',
    'PulsewayMissing',
    'PulsewayPortalMissing',
    'SophosMissing',
    'SophosCentralMissing',
    'ThreatLockerMissing',
    'ThreatLockerPortalMissing',
    'BitLockerMissing',
    'LastUpdated'
];

// Priority fields for DeviceDialog - shows these fields first
export const DEVICE_DIALOG_PRIORITY_FIELDS = [
    ...DEVICE_TABLE_DEFAULT_FIELDS,
    'VncPassword',
    'LocalAdminPassword',
    'DeviceId'
];

// Default export fields for device CSV exports (reuses table defaults)
export const DEFAULT_EXPORT_DEVICE_FIELDS = DEVICE_TABLE_DEFAULT_FIELDS;

// Fields to ignore when exporting individual devices
export const DEFAULT_EXPORT_DEVICE_IGNORE_FIELDS = [
    'VncPassword',
    'LocalAdminPassword'
];

// Default export fields for summary CSV exports
export const DEFAULT_EXPORT_SUMMARY_FIELDS = [
    'SiteName',
    'PulsewayGroupName',
    'TotalDevices',
    'TotalWindows10Devices',
    'TotalWindows11Devices',
    'TotalLaptopCount',
    'HardwareReadinessCapable',
    'HardwareReadinessNotCapable',
    'HardwareReadinessUndetermined',
    'NewestDeviceUpdate',
    'OldestDeviceUpdate',
    'TotalMissingPulseway',
    'TotalMissingSophos',
    'TotalMissingThreatLocker'
];
